import DownloadReport from "@routes/Keyword/templates/AseanInsights/components/DownloadReport";
import { DOWNLOAD_BUTTON_ATTRIBUTES } from "@routes/Keyword/templates/AseanInsights/utils/constants";
import { cn } from "@util/helpers";

type ContentProps = {
  /** The URL of the attachment do be viewed/downloaded. */
  attachmentURL: string;
};

/**
 * The lead report content component for the Asean Insights template.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=20436-71279&m=dev
 */
const Content = ({ attachmentURL }: ContentProps): React.ReactElement => {
  return (
    <div
      className="absolute inset-0 bg-gradient-asean-insights-mobile lg:bg-none"
      data-testid="lead-report-content-component"
    >
      <div
        className={cn(
          "absolute bottom-0 left-0 right-0 mt-auto flex max-w-full flex-col justify-center px-6 pb-10",
          "lg:ml-auto lg:h-full lg:w-[47.25rem] lg:bg-gradient-asean-insights-desktop lg:px-[8.25rem] lg:py-[6.25rem] lg:pt-20"
        )}
      >
        <p className="mb-0 font-poppins text-lg font-normal tracking-2% text-white lg:text-4xl">
          THE BUSINESS TIMES INSIGHTS
        </p>

        <h1 className="mb-2 text-balance font-lct text-9xl font-bold !leading-[120%] tracking-normal text-white lg:mb-6 lg:text-11xl">
          Asean Intelligence 2026
        </h1>

        <p className="mb-4 font-poppins text-xs font-normal leading-normal text-white lg:mb-6 lg:text-base">
          {
            "Where is capital flowing to? What do companies see as the top risks and key bets? Get the insider view from our exclusive survey of business leaders and decision makers in Asean."
          }
        </p>

        <DownloadReport
          attributes={DOWNLOAD_BUTTON_ATTRIBUTES.hero}
          attachmentURL={attachmentURL}
        />

        <p className="font-poppins text-4xs font-light leading-normal text-white lg:text-xs">
          {
            "Asean Intelligence is The Business Times' flagship regional survey on outlook and opportunities in the region."
          }
        </p>
      </div>
    </div>
  );
};

export default Content;
